import { Route, Routes } from "react-router-dom"
import { createGlobalStyle, ThemeProvider } from "styled-components"

import Home from "./Pages/Home"
import Login from "./Pages/Login"
import LightTheme from "./Theme/light"
import DarkTheme from "./Theme/dark"

import "./App.css"
import Button from "./components/common/Button"
import { useState } from "react"

const GlobalStyle = createGlobalStyle`
body{
  background: ${(p) => p.theme.bodyBackgroundColor};
  min-height: 100vh;
  margin: 0;
  color: ${(p) => p.theme.bodyFontColor};
  font-family:'Courier New', Courier, monospace
}
`

function App() {
  const [theme, setTheme] = useState(LightTheme)
  return (
    <ThemeProvider
      theme={{
        ...theme,
        setTheme: () => {
          setTheme((s) => (s.id === "light" ? DarkTheme : LightTheme))
        },
      }}
    >
      <GlobalStyle />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </ThemeProvider>
  )
}

export default App
